import { formatQuantity } from '../../utils/formatUtils'
import i18n from '../../utils/i18n'

export const ValueWithUnitBodyTemplate = (
  value: number,
  unit: string,
  fractionDigits = 3,
) => {
  if (value === null || value === undefined) return null

  const { language } = i18n

  if (isNaN(value)) return <></>

  const translationKey = `units.${unit?.toUpperCase()}`
  const translatedUnit = i18n.t(`common.${translationKey}`)
  // Fallback: If no translations is found show the original unit
  const displayUnit = translatedUnit === translationKey ? unit : translatedUnit

  return (
    <>
      {formatQuantity(value, fractionDigits, language)}&nbsp;
      {unit && displayUnit}
    </>
  )
}
